<template>
  <a-modal
    :title="modalTitle"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    :okButtonProps="{ props: {disabled:disabled} }"
    @ok="handleSubmit"
    @cancel="visible=false"
  >
    <a-form layout="horizontal" :form="form" @submit="handleSubmit">
      <a-form-item label="标题" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
          type="text"
          v-decorator="[
            'title',
            {rules: [{ required: true, message: '请输入标题' }]}
          ]"
          :disabled="disabled"
        />
      </a-form-item>
      <a-form-item
        label="广告图"
        :labelCol="{lg: {span: 7}}"
        :wrapperCol="{lg: {span: 13}}"
        :required="true"
        :help="courseHelpTxt"
        validateStatus="error"
      >
        <c-upload ref="imgUrl" :ossType="'course'" :isSingle="true" @uploadSuccess="uploadSuccess"></c-upload>
      </a-form-item>
      <a-form-item label="优先级" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input-number
          :min="0"
          :disabled="disabled"
          v-decorator="[
                  'priority',
                  {initialValue:0},
                  {rules: [{ required: false, min:0, message: '优先级' }]}
                ]"
        />&emsp;数字越大越靠前显示
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import webSiteCourse from "../../api/webSiteCourse";
import notification from "ant-design-vue/es/notification";
import CUpload from "../../components/CUpload/CUpload";

export default {
  name: "webSitecourseForm",
  components: { CUpload },
  data() {
    return {
      roleId: 0,
      modalTitle: "",
      type: "",
      id: -1,
      visible: false,
      confirmLoading: false,
      disabled: false, //是否禁止编辑
      imgUrl: "", //Course图片地址
      courseHelpTxt: ""
    };
  },
  methods: {
    //初始化，显示
    init(type, params) {
      this.id = params.id;
      this.type = type;
      this.visible = true;
      let id = this.id;
      //获取详情
      if (this.type == "add") {
        this.disabled = false;
        this.modalTitle = "新增广告";
        this.form.resetFields();
        setTimeout(() => {
          this.$refs.imgUrl.imageUrl = "";
        }, 100);
      }
      //获取详情
      if (this.type == "edit") {
        this.disabled = false;
        this.modalTitle = "修改广告";
        this.getDetail(id);
      }
    },
    //提交
    handleSubmit(e) {
      console.log("img", this.imgUrl);
      e.preventDefault();
      if (this.imgUrl == "") {
        this.courseHelpTxt = "请上传广告图片";
      }
      this.form.validateFields((err, values) => {
        console.log("v", values);
        //校验通过
        if (!err && this.courseHelpTxt == "") {
          let newValues = {
            title: values.title ? values.title : "",
            imgUrl: this.imgUrl,
            priority: values.priority ? values.priority : 0
          };
          newValues.moduleType = 1;
          if (this.type == "add") {
            //  console.log(newValues);
            this.add(newValues);
          }
          if (this.type == "edit") {
            this.edit(newValues);
          }
        }
      });
    },
    //新增
    add(params) {
      webSiteCourse.add(params).then(res => {
        console.log("数据：", res);
        notification.success({
          message: "消息",
          description: "新增成功！"
        });
        // let currentPage = this.$parent.pagination.current;
        // let pageSize = this.$parent.pagination.pageSize;
        let currentPage = 1;
        let pageSize = 10;
        this.$parent.getCourseList({ currentPage, pageSize });
        this.visible = false;
      });
    },
    //修改
    edit(params) {
      params.id = this.id;
      webSiteCourse.edit(params).then(res => {
        console.log("数据：", res);
        notification.success({
          message: "消息",
          description: "修改成功！"
        });
        // let currentPage = this.$parent.pagination.current;
        // let pageSize = this.$parent.pagination.pageSize;
        let currentPage = 1;
        let pageSize = 10;
        this.$parent.getCourseList({ currentPage, pageSize });
        this.visible = false;
      });
    },
    //获取详情
    getDetail(id) {
      webSiteCourse.detail({ id }).then(res => {
        // console.log(res);
        let course = res.data;
        console.log(course);
        let detail = {
          title: course.title
        };
        this.imgUrl = res.data.imgUrl;
        this.$refs.imgUrl.imageUrl = res.data.imgUrl;
        setTimeout(() => {
          this.form.setFieldsValue(detail);
        }, 100);
      });
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    uploadSuccess(e) {
      console.log("e", e);
      this.courseHelpTxt = "";
      this.imgUrl = e ? e : "";
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "dynamic_form_item" });
  },
  created() {}
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
.cl-inner {
  width: calc(100% - 40px);
  padding: 50px 20px 30px;
  background: white;
  margin: 20px auto;
}
.ap-form {
  width: 400px;
}
.form-oper {
  text-align: center;
  button {
    margin: 0px 5px;
  }
}
</style>